import { createContext, useContext } from "react";

// The signed-in user's dreams and fears, from NudgeApp's one listener each: `{ dreams, fears }`, the results of
// usePlanItems and useStatements. The task editor's Dream and Fear fields and Radar's Dreams and Fears read them here.
// A listener per editor would download every dream's photo each time a task opened.
export const TaskLinksContext = createContext(null);
export const useTaskLinkLists = () => useContext(TaskLinksContext);
